import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import Message from './message'
import GameModal from '../../containers/game-modal'
import OpenGameModal from '../../containers/open-game-modal'
import OpenGameForm from '../open-game-form'
import Cable from 'actioncable'

function Notifications({notifications, user, socketUrl, onRead, onDelete, onReadAll, onDeleteAll, onReceived}) {
  const unseenCount = notifications.reduce((acc, data) => { return data.seen ? acc : acc + 1 }, 0)
  const dropdownRef = useRef()
  const aRef = useRef()
  const [showList, setShowList] = useState(false)
  const [showGame, setShowGame] = useState(null)
  const [showOpenGame, setShowOpenGame] = useState(null)
  const [showOpenGameForm, setShowOpenGameForm] = useState(null)
  const emptyList = !notifications.length

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (showList && dropdownRef.current && !dropdownRef.current.contains(e.target) && !aRef.current.contains(e.target)) {
        setShowList(false)
      }
    }
    document.addEventListener('mousedown', checkIfClickedOutside)
    const cable = Cable.createConsumer(socketUrl)
    const userChannel = cable.subscriptions.create({
      channel: 'UserChannel',
      user_id: user.id
    }, {
      received: (data) => { onReceived(data.message) }
    })
    return () => {
      document.removeEventListener('mousedown', checkIfClickedOutside)
      cable.subscriptions.remove(userChannel)
    }
  }, [showList])

  const addNotifications = () => {
    return <ul className=''>
    { notifications.map(notification => <Message 
        key={notification.id}
        notification={notification}
        onRead={onRead}
        onShow={onShowGame}
        onDelete={onDelete}
      />) 
    }
    </ul>
  }

  const onShowGame = (gameId) => {
    user.sd_admin ? setShowOpenGame(gameId) : setShowGame(gameId)
  }

  const duplicateGame = (id) => {
    setShowOpenGame(null)
    setShowOpenGameForm({type: 'duplicate', id: id})
  }

  return <div>
    { showGame &&
      <GameModal
        gameId={showGame}
        socketUrl={socketUrl}
        onClose={() => setShowGame(null)}
      /> 
    }
    { showOpenGame &&
      <OpenGameModal
        activeTab='game-details'
        gameId={showOpenGame}
        socketUrl={socketUrl}
        onClose={() => setShowOpenGame(null)}
        onDuplicate={duplicateGame}
        onEdit={(data) => setShowOpenGameForm(data) }
        onCancel={() => setShowOpenGame(null)}
      /> 
    }
    { showOpenGameForm &&
      <OpenGameForm
        type={showOpenGameForm.type} 
        id={showOpenGameForm.id} 
        recurringId={showOpenGameForm.recurringId}
        params={showOpenGameForm.params}
        onClose={() => setShowOpenGameForm(false)}
        onUpdate={() => setShowOpenGameForm(false)}
      /> 
    }
    <a className='notifications btn btn-green' ref={aRef} onClick={() => setShowList(!showList)}>{unseenCount}</a>
    { showList &&
      <div className='notifications-content' ref={dropdownRef}>
        { !emptyList && addNotifications() }
        { !emptyList && 
          <div className='btn-group'>
            <a className='btn btn-default mark_seen' onClick={onReadAll} disabled={!unseenCount}>
              <div className='fa fa-check'></div>&nbsp;Mark all as read
            </a>
            <a className='btn btn-default' onClick={onDeleteAll}>
              <div className='fa fa-trash'></div>&nbsp;Clear all
            </a>
          </div>
        }
        { emptyList && <div className='no-notifications'>You have no notifications</div>}
      </div>
    }
  </div>
}

Notifications.propTypes = {
  notifications: PropTypes.array.isRequired,
  user: PropTypes.object.isRequired,
  socketUrl: PropTypes.string.isRequired,
  onRead: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onReadAll: PropTypes.func.isRequired,
  onDeleteAll: PropTypes.func.isRequired,
  onReceived: PropTypes.func.isRequired
}

export default Notifications
